import React from 'react';

const ApiClientContext = React.createContext(null);

export default ApiClientContext;
